import React from 'react';
import { Router } from 'react-static';
import { hot } from 'react-hot-loader';
import { I18nextProvider } from 'react-i18next';

import i18n from 'i18n';

import getParam from 'utils/getParam';
import getFromAccountsExecutor from 'utils/getFromAccountsExecutor';

import AppRoutesWrapper from './AppRoutesWrapper';

class App extends React.PureComponent {
  componentDidMount() {
    const affiliate = getParam(window.location.href, 'affiliate');
    if (affiliate) {
      getFromAccountsExecutor('set-affiliate', { affiliate });
    }
  }

  render() {
    // serverI18next is passed from static.config.js during build phase
    // after that, the component will use i18n instance in client side.
    const i18nInstance = this.props.serverI18next || i18n;
    return (
      <Router>
        <I18nextProvider i18n={i18nInstance}>
          <AppRoutesWrapper />
        </I18nextProvider>
      </Router>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// ../src/components/App/index.jsx